import React, { useState } from 'react';

import LandingPage from '../LandingPage';
import SkipVideo from '../SkipVideo';
import Timeline from '../Timeline';
import RotateScreen from '../RotateScreen';

import translations from '../data';

import './styles.css';

const MaxBraun = () => {
  const [currentState, setCurrentState] = useState('landing');

  const { rotateTexts } = translations;

  return (
    <div className="max-braun-timeline">
      <RotateScreen title={rotateTexts.title} subtitle={rotateTexts.subtitle} />
      {currentState === 'landing' && (
        <LandingPage
          showNext={() => {
            setCurrentState('videoIntro');
          }}
        />
      )}
      {currentState === 'videoIntro' && (
        <SkipVideo
          showNext={() => {
            setCurrentState('timeline');
          }}
        />
      )}
      {currentState === 'timeline' && <Timeline />}
    </div>
  );
};

export default MaxBraun;
